import { FormSelectProps } from '@unistocks/components/form/components/fields/form-select';
import { Form } from '@unistocks/components/form/form';
import { DateConstant } from '@unistocks/proxy/axios-client';
import { t } from '@unistocks/shared/localization/index.ts';
import { translateEnumOptions } from '@unistocks/shared/utils/enum-utils';
import { dateConstantOptions } from '@unistocks/shared/utils/enums/date-constant';
import { FieldValues, Path } from 'react-hook-form';

export type PeriodSelectProps<TFieldValues extends FieldValues = FieldValues> = Partial<
  FormSelectProps<DateConstant, TFieldValues>
> & {
  isValidOption?: (options: DateConstant) => boolean;
};

export const PeriodSelect = <TFieldValues extends FieldValues = FieldValues>({
  name = 'period' as Path<TFieldValues>,
  isValidOption,
  ...props
}: PeriodSelectProps<TFieldValues>) => {
  const options = translateEnumOptions(
    dateConstantOptions.filter(({ value }) => isValidOption?.(value) ?? true)
  );

  return (
    <Form.Select
      name={name}
      label={t('::Dashboard:Settings:DateRange')}
      options={options}
      isRequired
      {...props}
    />
  );
};
